/**
 * Эталонное время сервера для таймеров.
 *
 * Все отсчёты (время на заезд, остаток мойки, химия) считаются как «лимит минус прошло».
 * «Прошло» брали по часам устройства, поэтому ушедшие часы искажали отсчёт: на кассирском
 * ПК, отстающем на ~3 минуты, трёхминутный таймер заезда показывал 6:13.
 *
 * Поправку берём из заголовка Date, который есть у любого HTTP-ответа, — отдельный
 * запрос за временем не нужен.
 */

// Пока расхождение в пределах десятка секунд, считаем часы устройства исправными.
const DEAD_ZONE_MS = 10 * 1000;

// Date имеет точность до секунды, а к моменту чтения ответа проходит ещё и задержка сети.
// Без порога поправка пересчитывалась бы на каждом опросе и отсчёт дёргался бы на ±1 секунду.
const UPDATE_THRESHOLD_MS = 5 * 1000;

let offsetMs = 0;

/**
 * Уточняет поправку по заголовкам ответа. Вызывается из перехватчиков axios.
 * @param {Object} headers - заголовки ответа (объект axios или AxiosHeaders)
 */
export function syncServerTime(headers) {
  if (!headers) return;

  const raw = typeof headers.get === 'function' ? headers.get('date') : headers.date;
  if (!raw) return;

  const serverMs = Date.parse(raw);
  if (Number.isNaN(serverMs)) return;

  const measured = serverMs - Date.now();
  const next = Math.abs(measured) < DEAD_ZONE_MS ? 0 : measured;

  if (Math.abs(next - offsetMs) > UPDATE_THRESHOLD_MS) {
    offsetMs = next;
  }
}

/**
 * Текущее время сервера. До первого ответа API совпадает с локальным.
 * @returns {Date}
 */
export function serverNow() {
  return new Date(Date.now() + offsetMs);
}

/**
 * Текущее время сервера в миллисекундах.
 * @returns {number}
 */
export function serverNowMs() {
  return Date.now() + offsetMs;
}

/**
 * Насколько часы устройства расходятся с сервером (мс). Для диагностики.
 * @returns {number}
 */
export function getClockOffsetMs() {
  return offsetMs;
}
